"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCanStoreDeliver = exports.fetchFindDeliveryStore = exports.fetchGetClosestStores = exports.fetchStoreOrderingHours = exports.fetchStore = void 0;

var _tslib = require("tslib");

var _api = require("../api");

var _types = require("./types");

var fetchStore = function fetchStore(locationNumber) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.get(_types.Endpoints.Store + "/" + locationNumber).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchStore = fetchStore;

var fetchStoreOrderingHours = function fetchStoreOrderingHours(_a) {
  var locationNumber = _a.locationNumber,
      type = _a.type,
      prepTimeInMinutes = _a.prepTimeInMinutes;
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_b) {
      return [2
      /*return*/
      , _api.api.post(_types.Endpoints.OrderingHours + "/" + locationNumber + "/ordering-hours", {
        type: type,
        prepTimeInMinutes: prepTimeInMinutes
      }).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchStoreOrderingHours = fetchStoreOrderingHours;

var fetchGetClosestStores = function fetchGetClosestStores(payload) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.post("" + _types.Endpoints.GetClosestStores, payload).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchGetClosestStores = fetchGetClosestStores;

var fetchFindDeliveryStore = function fetchFindDeliveryStore(payload) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.post("" + _types.Endpoints.FindDeliveryStore, payload).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchFindDeliveryStore = fetchFindDeliveryStore;

var fetchCanStoreDeliver = function fetchCanStoreDeliver(payload, locationNumber) {
  return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
    return (0, _tslib.__generator)(this, function (_a) {
      return [2
      /*return*/
      , _api.api.post("v1/store/" + locationNumber + "/can-deliver", payload).then(function (res) {
        return res.data;
      })];
    });
  });
};

exports.fetchCanStoreDeliver = fetchCanStoreDeliver;